import api from '..'
/* import { sortTableEnum } from 'enum/sortTable.enum';
 */
const hierarchyList = (
  page: number,
  searchText: string,
  sort: any,
  perPage: number
) => {
  const order = [`${sort.field} ${sort.order}`]

  return api
    .get('administration/areas', {
      params: {
        page,
        search: searchText,
        order,
        per_page: perPage,
      },
    })
    .then(({ data, headers }) => {
      return {
        data: data.data.map(({ attributes }: any) => attributes),
        total: parseInt(headers['total']),
        perPage: parseInt(headers['per-page']),
      }
    })
}

export default hierarchyList
